import React from 'react'
import { PackQuantityMap, PriceMap } from '../productPricing/ProductPricingContext'
import { AddToCartResponse, GetProductsResponseItem } from './shared/WholesalerPublicApi'

export interface WholesalerContextShape {
  pricing: Readonly<Record<string, GetProductsResponseItem | null>>
  priceMap: PriceMap
  isFetchingPricing: boolean
  packQuantityMap: PackQuantityMap
  fetchWholesalerPrice: (itemNos: string[]) => void
  addToWholesalerCart(items: { itemNo: string, quantity: number }[]): Promise<AddToCartResponse>
  goToWholesalerCart(): Promise<void>
  brandName: string
  brandLogo: string
  priceIncludesGst: boolean
  entryPoint: string | null
}

export const WholesalerContext = React.createContext<WholesalerContextShape | null>(null)
